import { Dispatch } from 'redux';
import * as actions from './actionCatalog';
import * as http from '../http';
import { CDBurnerFilter } from 'reducers/burnerFiltersReducer';

const regularGetFilters = (dispatch: Dispatch) => http.get<CDBurnerFilter[]>(actions.GET_BURNER_FILTERS, dispatch);

export const getFilters = () => regularGetFilters;